module.exports = __webpack_public_path__ + "static/media/brazil.d7f58121.jpg";